export function unsuccessfulStatus(status) {
    return status > 299;
}

// FIX: a lot of the old code
// that uses `unsuccessfulStatus`
// will easily show promise.status into the function
// as no types are checked.
// TODO: remove this when fixed.
Promise.prototype.status = 1000;
Promise.prototype.detail = "[object Promise]";